import { getRandomGuid4 } from '@wix/user-feedback-common';

export const getSessionId = () => getRandomGuid4();
